import React from "react";

const adHocDoc = (
    <>
        <p>
            This is tactic tells the system to go straight into entry tactics.
        </p>
        <p>
            Ex: if you dont want to utilize any of the setups, and would like to buy
            just on a break of a candle, you would set setup to adhoc, and entry tactic
            to candleBreak.
        </p>
    </>
);

export default adHocDoc;
